import { createRouterSelector } from '@atlassian/react-resource-router';

export const useQueryParams = createRouterSelector((state) => state.query);
export const usePathParams = createRouterSelector((state) => state.match.params);
export const useCurrentRoute = createRouterSelector((state) => state.route);
